module.exports = __webpack_public_path__ + "static/computer-ab55c5b2836acf0957b95cf4386a0ad8.png";